import React, { useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import config from "../../config.js";

// Redux
import { login } from "../../actions/auth";

// Import the UI components
import { Button, TextInput, Card, Spinner, Alert, Text } from "evergreen-ui";

const Login = ({
  login,
  isAuthenticated,
  loading,
  currentRegistrationIntake,
}) => {
  // Define the state
  const [formData, setData] = useState({
    username: "",
    password: "",
  });

  let from = useLocation().state || { from: { pathname: "/" } };

  // Extract the state
  const { username, password } = formData;

  const [loginError, setLoginError] = useState(false);
  // Set the state
  const onChange = (e) => {
    setData({ ...formData, [e.target.name]: e.target.value });
  };

  // On submit/click
  const onClick = async (e) => {
    e.preventDefault();
    // Check the current page
    const path = window.location.pathname;

    let staffLogin = false;
    if (path == "/stafflogin") {
      staffLogin = true;
    }

    // Run the action & check if login was successful
    const r = await login(username, password, staffLogin);
    if (r === "failed") {
      setLoginError(true);
    } else {
      setLoginError(false);
    }
  };

  // Check if user is logged in
  if (isAuthenticated) {
    return <Redirect to={from.from.pathname} />;
  }

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      {/* <Alert intent="none" appearance="card" title="College is closed on the following days: Dec. 24th to Dec. 28th, Dec. 31st to Jan. 3rd, and all weekends"/> */}
      <form>
        <Card
          className="loginForm"
          elevation={2}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          style={{ padding: "10px 0", height: "450px" }}
        >
          <img width="280" src="./img/logo.png" />
          <TextInput
            name="username"
            placeholder="Username"
            label="Username"
            onChange={(e) => onChange(e)}
          />
          <TextInput
            name="password"
            placeholder="Password"
            label="Your Password"
            type="password"
            onChange={(e) => onChange(e)}
          />
          {loginError && <Text color="red">Invalid Username or Password</Text>}
          <Button
            appearance="primary"
            height="40"
            width="80%"
            intent={config.theme.primary}
            style={{ boxShadow: "none" }}
            onClick={(e) => onClick(e)}
          >
            Login
          </Button>
          <a href={config.forgetPassword}>Forget Password?</a> <br />
          {currentRegistrationIntake && (
            <a
              href="/register"
              style={{ color: "darkblue", marginTop: "-5px" }}
            >
              {`Register for  ${currentRegistrationIntake} `}
              Intake
            </a>
          )}
        </Card>
      </form>
    </>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  // auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  currentRegistrationIntake: state.auth.currentRegistrationIntake,
});

export default connect(mapStateToProps, { login })(Login);
